<style>
.v-tab {
    text-transform: none !important;
}
.addon-layout {
    display: flex;
    gap: 0;
}
.addon-sidebar {
    width: 170px;
    min-width: 170px;
    border-right: 1px solid #e0e0e0;
    background: white;
    padding-top: 8px;
}
.addon-content {
    flex: 1;
    min-width: 0;
    padding-left: 16px;
}
.sidebar-section {
    padding: 12px 0 4px 12px;
    font-size: 10px;
    font-weight: 500;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.sidebar-section:first-child {
    padding-top: 0;
}
.sidebar-item {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.sidebar-item:hover {
    background: #e8e8e8;
}
.sidebar-item.active {
    background: #f5f5f5;
    color: #1976d2;
    font-weight: 500;
    border-left: 3px solid #1976d2;
    padding-left: 9px;
}
.sidebar-badge {
    background: #9e9e9e;
    color: white;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 10px;
    min-width: 18px;
    text-align: center;
}
.component-usage-box {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: -12px;
    font-size: 11px;
    color: #999;
}
.component-usage-box code {
    font-family: monospace;
    font-size: 11px !important;
    color: #999 !important;
    background: none !important;
    padding: 0 !important;
}
</style>

<template>
  <div v-if="addon">
    <confirm-remove ref="confirmremove" />
    <div class="title">{{addon.name}}{{!$root.supplier || addon.supplier_id != $root.supplier.id ? ' ' + $translate('by') + ' ' + selectedVersion.supplier_name : ''}}</div>
      <v-form v-model="valid">
        <v-select
                :items="addon.versions"
                :label="$translate('Select version')"
                solo
                v-model="selectedVersion"
                :item-text="getVersionName"
                return-object
                @change="versionSelected"
        ></v-select>

        <div class="addon-layout">
          <div class="addon-sidebar">
            <div class="sidebar-section">{{ $translate('Info') }}</div>
            <div class="sidebar-item" :class="{active: tab === TAB.info}" @click="tab = TAB.info">{{ $translate('Store information') }}</div>
            <div class="sidebar-item" :class="{active: tab === TAB.description}" @click="tab = TAB.description">{{ $translate('Feature description') }}</div>
            <div class="sidebar-item" :class="{active: tab === TAB.price}" @click="tab = TAB.price">{{ $translate('Price') }}</div>

            <div class="sidebar-section">{{ $translate('Settings') }}</div>
            <div class="sidebar-item" :class="{active: tab === TAB.settings}" @click="tab = TAB.settings">
              {{ $translate('Settings') }}
              <span v-if="changed.settings.length > 0" class="sidebar-badge">{{changed.settings.length}}</span>
            </div>
            <div class="sidebar-item" :class="{active: tab === TAB.notifications}" @click="tab = TAB.notifications">
              {{ $translate('Notifications') }}
            </div>

            <div class="sidebar-section">{{ $translate('Development') }}</div>
            <div class="sidebar-item" :class="{active: tab === TAB.apis}" @click="tab = TAB.apis">
              {{ $translate('APIs') }}
              <span v-if="changed.apis.length > 0" class="sidebar-badge">{{changed.apis.length}}</span>
            </div>
            <div class="sidebar-item" :class="{active: tab === TAB.functions}" @click="tab = TAB.functions">
              {{ $translate('Functions') }}
              <span v-if="changed.functions.length > 0" class="sidebar-badge">{{changed.functions.length}}</span>
            </div>
            <div class="sidebar-item" :class="{active: tab === TAB.components}" @click="tab = TAB.components">
              {{ $translate('Components') }}
              <span v-if="changed.components.length > 0" class="sidebar-badge">{{changed.components.length}}</span>
            </div>
            <div class="sidebar-item" :class="{active: tab === TAB.mailinghandlers}" @click="tab = TAB.mailinghandlers">
              {{ $translate('Mailing handlers') }}
              <span v-if="changed.mailinghandlers.length > 0" class="sidebar-badge">{{changed.mailinghandlers.length}}</span>
            </div>
            <div class="sidebar-item" :class="{active: tab === TAB.webhooks}" @click="tab = TAB.webhooks">
              {{ $translate('Webhooks') }}
              <span v-if="changed.webhooks.length > 0" class="sidebar-badge">{{changed.webhooks.length}}</span>
            </div>
            <div class="sidebar-item" :class="{active: tab === TAB.widgets}" @click="tab = TAB.widgets">
              {{ $translate('Widgets') }}
              <span v-if="changed.widgets.length > 0" class="sidebar-badge">{{changed.widgets.length}}</span>
            </div>

            <div class="sidebar-section">{{ $translate('Review') }}</div>
            <div class="sidebar-item" :class="{active: tab === TAB.review}" @click="tab = TAB.review">{{ $translate('Review') }}</div>
            <div class="sidebar-item" :class="{active: tab === TAB.log}" @click="tab = TAB.log">{{ $translate('Log') }}</div>
          </div>

          <div class="addon-content">
            <v-tabs-items v-model="tab" touchless>
          <v-tab-item class="pa-4">
            <v-row>
              <v-col cols=12 md=6>
                <v-text-field v-model="changed.name" :readonly="readonly" :label="$translate('Name')" :rules="nameRules" :placeholder="$translate('Enter addon name')"></v-text-field>
                <v-text-field v-model="changed.supplier_mail" :readonly="readonly" :rules="emailRules" :label="$translate('E-mail to support')"></v-text-field>
                <v-text-field v-model="changed.onstart_mail" :readonly="readonly" :rules="emailRules" :label="$translate('Send e-mail here when addon starts')"></v-text-field>
                <v-autocomplete :search-input.sync="tmp.modules" @change="tmp.modules = ''" v-model="changed.modules" :readonly="readonly" :label="$translate('Required base functionality')" :items="modules" item-text="name" item-value="id" :clearable="!readonly" multiple></v-autocomplete>
                <v-autocomplete :search-input.sync="tmp.permissions_granted" @change="tmp.permissions_granted = ''" v-model="changed.permissions_granted" :readonly="readonly" :label="$translate('Permissions the addon will be granted')" :items="permissions" item-text="name" item-value="id" :clearable="!readonly" multiple></v-autocomplete>
                <v-autocomplete v-model="changed.category" :readonly="readonly" :label="$translate('Belongs to category')" :items="categories" item-text="name" item-value="id" :clearable="!readonly"></v-autocomplete>

                <v-select
                  v-if="packages.length"
                  :items="packages"
                  :label="$translate('Enabled by default in branch packets')"
                  item-text="name"
                  item-value="name"
                  multiple
                  :readonly="readonly"
                  v-model="defaultForPackage"
                ></v-select>

                <v-select
                  v-if="packages.length"
                  :items="packages"
                  :label="$translate('Recommended for branch packets')"
                  item-text="name"
                  item-value="name"
                  multiple
                  :readonly="readonly"
                  v-model="recommendedForPackage"
                ></v-select>

                <v-textarea v-model="changed.description" :readonly="readonly" :label="$translate('Description')" :placeholder="$translate('Description of the addon that customers will see')" auto-grow></v-textarea>
                <v-textarea v-model="changed.onstart_text" :readonly="readonly" :label="$translate('Startup information')" :placeholder="$translate('Information shown to the customer when addon is added')" auto-grow></v-textarea>
              </v-col>
              <v-col cols=12 md=6>
                <v-row>
                  <v-col cols=12>
                    <v-card>
                      <v-card-title>{{ $translate('Image') }}</v-card-title>
                      <v-img v-if="changed.image"
                        :src="changed.image"
                        height="200px"
                        contain
                        @click="showImageDialog = true"
                      >
                      </v-img>

                      <v-dialog v-model="showImageDialog" max-width="90vw">
                        <v-card>
                          <v-img :src="changed.image" contain max-height="80vh"  />
                          <v-card-actions>
                            <v-spacer />
                            <v-btn @click="showImageDialog = false" color="secondary" text>{{ $translate('Close') }}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <div v-if="!changed.image" style="height: 200px">
                      </div>

                      <v-card-actions>
                        <div class="ma-4" style="width: 100%" v-if="loading.image">
                          <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                          ></v-progress-linear>
                        </div>

                        <v-spacer></v-spacer>

                        <v-btn icon @click="$refs.iuploader.click()" v-if="!readonly">
                          <input ref="iuploader" class="d-none" type="file" accept="image/*" @change="onImageChanged($event.target.files[0])">
                          <v-icon v-if="changed.image">mdi-pencil</v-icon>
                          <v-icon v-if="!changed.image">mdi-plus</v-icon>
                        </v-btn>

                        <v-btn v-if="changed.image && !readonly" icon @click="removeImage()">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols=12>
                    <v-card>
                      <v-card-title>{{ $translate('Screenshots') }}</v-card-title>

                      <v-carousel
                        height="200"
                        width="200"
                        :hide-delimiters="changed.screenshots.length == 0"
                        show-arrows-on-hover
                        v-model="selectedScreenshot">
                            <v-carousel-item
                              v-for="screenshot in changed.screenshots"
                              :key="screenshot"
                            >
                              <v-sheet
                                height="100%"
                                tile
                              >
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center"
                                >
                                <v-img :src="screenshot" max-height="200px" contain @click="showScreenshotDialog = true" />
                                </v-row>
                              </v-sheet>

                              <v-dialog v-model="showScreenshotDialog" max-width="90vw">
                              <v-card>
                                <v-img :src="screenshot" contain max-height="80vh"  />
                                <v-card-actions>
                                  <v-spacer />
                                  <v-btn @click="showScreenshotDialog = false" color="secondary" text>{{ $translate('Close') }}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                            </v-carousel-item>

                      </v-carousel>
                      <v-card-actions>
                        <div class="ma-4" style="width: 100%" v-if="loading.screenshot">
                          <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                          ></v-progress-linear>
                        </div>
                        <v-spacer></v-spacer>

                        <v-btn icon @click="$refs.uploader.click()" v-if="!readonly">
                          <input ref="uploader" class="d-none" type="file" accept="image/*" @change="onScreenshot($event.target.files[0])">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>

                        <v-btn v-if="changed.screenshots.length && !readonly" icon @click="removeScreenshot()">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-if="canRemove">
                  <v-col cols=12>
                    <v-btn text @click="remove" color="error"><v-icon left>mdi-delete</v-icon>{{ $translate('Remove addon') }}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item class="pa-4">
            <v-row>
              <v-col cols=12 md=12>
                <v-preview :item="changed" @update="changed.preview = $event;"></v-preview>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item class="pa-4">
            <v-row>
              <v-col cols=12 md=6>
                <v-text-field v-model="changed.start_fee" :readonly="readonly" type="number" suffix="kr" min=0 :label="$translate('Start fee')"></v-text-field>
                <v-text-field v-model="changed.price_per_month" :readonly="readonly" suffix="kr" type="number" min=0 :label="$translate('Price per month')"></v-text-field>
                <v-switch v-model="changed.use_transactions" :readonly="readonly" :label="$translate('Charge per') + ' ' + getUsageName(1)" @change="useTransactionsChange" />
                <v-text-field v-if="changed.use_transactions" v-model="changed.usage_name" :readonly="readonly" :label="$translate('Usage name')" type="text" :rules="requiredRules" :placeholder="$translate('Example: invoice,invoices')"></v-text-field>
                <v-text-field v-if="changed.use_transactions" v-model="changed.free_uses_per_month" :readonly="readonly" :label="$translate('Free') + ' ' + getUsageName(2) + ' ' + $translate('per month')" type="number" min=0></v-text-field>
                <v-text-field v-if="changed.use_transactions" v-model="changed.price_per_usage" :readonly="readonly" :rules="decimalRule" suffix="kr" min=0 :label="$translate('Price per') + ' ' + getUsageName(1)"></v-text-field>
                <v-text-field v-if="changed.use_transactions" v-model="changed.price_per_usage_percent" :readonly="readonly" :rules="decimalRule" suffix="%" :label="$translate('Percent per') + ' ' + getUsageName(1)"></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="$root.reviewer.list">
              <v-col cols=12>
                <v-btn v-if="!readonly" color="primary" dark class="mb-2" @click="newPriceRule()">{{ $translate('New price rule') }}</v-btn>
                <data-dialog ref="price_dialog" :fields="changed.use_transactions ? price_fields_transaction : price_fields" :title="$translate('Prices')" :readonly="readonly" />

                <v-data-table v-if="changed.price_rules && changed.price_rules.length > 0"
                    :headers="changed.use_transactions ? priceHeadersTransaction : priceHeaders"
                    :items="changed.price_rules"
                    :hide-default-header="$root.isSmallScreen"
                    :hide-default-footer="true"
                    class="elevation-1"
                    disable-sort
                    @click:row="priceRuleClick"
                    :items-per-page="1000"
                  >
                  <template v-slot:item.domain="{ item }">
                    {{getDomainNameFromId(item.domain_id)}}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="priceRuleClick(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      v-if="!readonly"
                      small
                      @click.stop="removePriceRule(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-row v-if="$root.reviewer.list">
              <v-col cols=12>
                <v-switch v-model="changed.for_all" :readonly="readonly" :label="$translate('Available for all Zoezi customers')" />

                <div v-if="!changed.for_all">
                  <v-btn v-if="!readonly" color="primary" dark class="mb-2" @click="newAvailableRule()">{{ $translate('New availability rule') }}</v-btn>
                  <data-dialog ref="available_dialog" :fields="available_fields" :title="$translate('Availability')" :readonly="readonly" />

                  <v-data-table
                      :headers="availableHeaders"
                      :items="changed.available_rules"
                      :hide-default-header="$root.isSmallScreen"
                      :hide-default-footer="true"
                      class="elevation-1"
                      disable-sort
                      @click:row="availableRuleClick"
                      :items-per-page="1000"
                    >
                    <template v-slot:item.chain="{ item }">
                      {{ item.inverted ? 'Ej ' : '' }}{{item.chain}}
                    </template>
                    <template v-slot:item.domain="{ item }">
                      {{getDomainNameFromId(item.domain_id)}}
                    </template>
                    <template v-slot:item.action="{ item }">
                      <v-icon
                        small
                        class="mr-2"
                        @click="availableRuleClick(item)"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon
                        v-if="!readonly"
                        small
                        @click.stop="removeAvailableRule(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>

          </v-tab-item>
          <v-tab-item>
            <div class="pa-4">
              <v-row>
                <v-col cols=12 md=4>
                  <v-input v-if="!changed.unique_apikey" :label="$translate('API key')" :hint="addon.apikey" persistent-hint></v-input>
                  <v-switch v-model="changed.unique_apikey" :readonly="readonly" :label="$translate('Each customer gets their own API key')" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols=12 md=4>
                  <v-input :label="$translate('Webhook key')" :hint="addon.webhookkey" persistent-hint></v-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols=12 md=6>
                  <v-select
                    :items="getTestSystems()"
                    :label="$translate('Test system')"
                    v-model="changed.test_hostname"
                    :readonly="readonly"
                    item-text="name"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols=12 md=6>
                  {{ $translate('In the test system you can log in and test the addon. Username for login:') }} <b>{{$root.supplier.mail}}</b><br>
                  {{ $translate('To start the addon, go to the Addon Store.') }}<br>
                  <br>
                  <a v-if="changed.test_hostname" :href="'https://' + changed.test_hostname + '/staff'" target="_blank">{{ $translate('Go to test system') }}</a>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols=12 md=6>
                <v-btn v-if="!readonly" color="primary" dark class="mb-2" @click="newSetting()">{{ $translate('New setting') }}</v-btn>
                <data-dialog ref="settings_dialog" :fields="settings_fields" :title="$translate('Setting')" :readonly="readonly" />

                <v-data-table v-if="changed.settings.length"
                    :headers="settingsHeaders"
                    :items="changed.settings"
                    :hide-default-header="$root.isSmallScreen"
                    :hide-default-footer="true"
                    sort-by="name"
                    must-sort
                    class="elevation-1"
                    @click:row="settingsClick"
                    :items-per-page="1000"
                  >
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="settingsClick(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      v-if="!readonly"
                      small
                      @click.stop="removeSetting(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row v-if="$root.reviewer.list">
              <v-col cols=12 md=6>
                <v-btn v-if="!readonly" color="primary" dark class="mb-2" @click="newPermission()">{{ $translate('New permission') }}</v-btn>
                <data-dialog ref="permissions_dialog" :fields="permissions_fields" :title="$translate('Permission')" :readonly="readonly" />

                <v-data-table v-if="changed.permissions_provided && changed.permissions_provided.length"
                    :headers="permissionsHeaders"
                    :items="changed.permissions_provided"
                    :hide-default-header="$root.isSmallScreen"
                    :hide-default-footer="true"
                    sort-by="id"
                    must-sort
                    class="elevation-1"
                    @click:row="permissionsClick"
                    :items-per-page="1000"
                  >
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="permissionsClick(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      v-if="!readonly"
                      small
                      @click.stop="removePermission(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

              <v-row>
                <v-col cols=12>
                  <h2 class="mt-2">Git</h2>
                  <div v-if="gitRepoStatus && gitRepoStatus.has_repo">
                    {{ $translate('Git is set up for this addon.') }}<br>
                    {{ $translate('To check out:') }}<br>
                    <code>{{gitRepoStatus.clone}}</code><br>
                  </div>
                  <div v-else>
                    <v-btn color="primary" @click="gitInit" :loading="loading.gitInit">{{ $translate('Initialize git for this addon') }}</v-btn>
                  </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item class="pa-4">
            <!-- Notifications tab -->
            <v-row>
              <v-col cols=12 md=8>
                <v-alert type="info" text class="mb-4">
                  {{ $translate('These settings apply to the addon as a whole and take effect immediately (no review required).') }}
                </v-alert>

                <h3 class="mb-4">{{ $translate('Notification Settings') }}</h3>

                <v-text-field
                  v-model="notificationSettings.notification_emails"
                  :rules="emailListRules"
                  :label="$translate('Notification email(s)')"
                  :hint="$translate('Comma-separated. Leave empty to use addon support email')"
                  persistent-hint
                  class="mb-4"
                ></v-text-field>

                <div class="mb-4">
                  <div class="text-subtitle-2 mb-2">{{ $translate('Notify on') }}:</div>
                  <v-checkbox
                    v-model="notificationSettings.notification_errors"
                    :label="$translate('Errors')"
                    hide-details
                    class="mt-0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="notificationSettings.notification_warnings"
                    :label="$translate('Warnings')"
                    hide-details
                    class="mt-0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="notificationSettings.notification_info"
                    :label="$translate('Info')"
                    hide-details
                    class="mt-0"
                  ></v-checkbox>
                </div>

                <div class="mb-4">
                  <div class="text-subtitle-2 mb-2">{{ $translate('Frequency') }}:</div>
                  <v-radio-group v-model="notificationSettings.notification_mode" class="mt-0">
                    <v-radio value="smart">
                      <template v-slot:label>
                        <div>
                          <strong>{{ $translate('Smart') }}</strong>
                          <div class="text-caption text--secondary">{{ $translate('Backoff after repeated errors: 1h, 4h, then daily') }}</div>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio value="always">
                      <template v-slot:label>
                        <div>
                          <strong>{{ $translate('Always') }}</strong>
                          <div class="text-caption text--secondary">{{ $translate('Max 1 per hour per error type') }}</div>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio value="disabled">
                      <template v-slot:label>
                        <div>
                          <strong>{{ $translate('Disabled') }}</strong>
                          <div class="text-caption text--secondary">{{ $translate('No email notifications') }}</div>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>

                <v-divider class="mb-4"></v-divider>

                <v-btn
                  color="primary"
                  @click="saveNotificationSettings"
                  :loading="loading.saveNotifications"
                  :disabled="!notificationSettingsChanged"
                  class="mr-2"
                >
                  {{ $translate('Save notification settings') }}
                </v-btn>

                <v-divider class="my-4"></v-divider>

                <v-btn
                  color="secondary"
                  @click="sendTestNotification"
                  :loading="loading.testNotification"
                  :disabled="notificationSettingsChanged"
                  class="mr-2"
                >
                  {{ $translate('Send test notification') }}
                </v-btn>
                <v-btn
                  color="secondary"
                  outlined
                  @click="triggerTestError"
                  :loading="loading.testError"
                  :disabled="notificationSettingsChanged"
                >
                  {{ $translate('Trigger test error') }}
                </v-btn>
                <div v-if="notificationSettingsChanged" class="text-caption mt-2 text--secondary">
                  {{ $translate('Save notification settings before testing') }}
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols=12 md=6>
                <v-btn color="primary" dark class="mb-2" @click="newWidget()" v-if="!readonly">{{ $translate('New widget') }}</v-btn>
                <data-dialog ref="widget_dialog" :fields="widget_fields" :title="$translate('Widget')" :readonly="readonly" />

                <v-data-table v-if="changed.widgets.length"
                    :headers="widgetHeaders"
                    :items="changed.widgets"
                    :hide-default-header="$root.isSmallScreen"
                    :hide-default-footer="true"
                    sort-by="name"
                    item-value="id"
                    must-sort
                    class="elevation-1"
                    @click:row="widgetClick"
                    :items-per-page="1000"
                  >
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="widgetClick(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      v-if="!readonly"
                      small
                      @click.stop="removeWidget(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <template v-slot:item.type="{ item }">
                    {{widgetType(item.type)}}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols=12 md=6>
                <v-dialog v-model="showWebhookDialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on" :disabled="readonly">{{ $translate('New webhook') }}</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Webhook</span>
                    </v-card-title>

                    <v-card-text>
                      <v-text-field v-model="editingWebhookItem.name" :label="$translate('Name')" :readonly="readonly"></v-text-field>
                      <v-switch v-model="editingWebhookItem.useFunction" :label="$translate('Use built-in function')" :readonly="readonly" />
                      <v-select v-if="editingWebhookItem.useFunction"
                        v-model="editingWebhookItem.functionName"
                        :label="$translate('Function')"
                        :items="changed.functions"
                        item-value="id"
                        item-text="name"
                        :readonly="readonly"
                      ></v-select>
                      <v-text-field v-if="!editingWebhookItem.useFunction" v-model="editingWebhookItem.url" label="URL"></v-text-field>

                      <v-autocomplete
                        :items="events"
                        :label="$translate('Events')"
                        :item-text="getEventName"
                        item-value="id"
                        multiple
                        :readonly="readonly"
                        v-model="editingWebhookItem.events"
                        :search-input.sync="tmp.webhook" @change="tmp.webhook = ''"
                      ></v-autocomplete>

                      <v-select
                        :items="webhook_actions"
                        :label="$translate('Event filter')"
                        item-text="name"
                        item-value="id"
                        multiple
                        :readonly="readonly"
                        v-model="editingWebhookItem.actions"
                      ></v-select>

                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" text @click="closeWebhook">{{ $translate('Cancel') }}</v-btn>
                      <v-btn color="primary" text @click="saveWebhook" :disabled="readonly || !editingWebhookItem.name">{{ $translate('Save') }}</v-btn>
                    </v-card-actions>
                  </v-card>

                </v-dialog>

                <v-data-table v-if="changed.webhooks.length"
                    :headers="webhookHeaders"
                    :items="changed.webhooks"
                    :hide-default-header="$root.isSmallScreen"
                    :hide-default-footer="true"
                    sort-by="name"
                    must-sort
                    class="elevation-1"
                    @click:row="webhookClick"
                    :items-per-page="1000"
                  >
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="webhookClick(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon v-if="!readonly"
                      small
                      @click.stop="removeWebhook(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <!-- Utskickshanterare -->
            <v-row>
              <v-col cols=12 md=6>
                <v-btn color="primary" dark class="mb-2" @click="newMailingHandler()" v-if="!readonly">{{ $translate('New mailing handler') }}</v-btn>
                <data-dialog ref="mailinghandler_dialog" :fields="mailinghandler_fields" :title="$translate('Mailing handler')" :readonly="readonly" />

                <v-data-table v-if="changed.mailinghandlers.length"
                    :headers="mailingHandlerHeaders"
                    :items="changed.mailinghandlers"
                    :hide-default-header="$root.isSmallScreen"
                    :hide-default-footer="true"
                    sort-by="name"
                    item-value="id"
                    must-sort
                    class="elevation-1"
                    @click:row="mailingHandlerClick"
                    :items-per-page="1000"
                  >
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="mailingHandlerClick(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      v-if="!readonly"
                      small
                      @click.stop="removeMailingHandler(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <!-- Komponenter -->
            <v-row>
              <v-col cols=12>
                <v-btn v-if="!readonly" color="primary" @click="newComponent">{{ $translate('New component') }}</v-btn>
              </v-col>
            </v-row>

            <v-row v-if="changed.components && changed.components.length" align="center">
              <v-col cols=12 md=6>
                <v-select
                  :items="sortedComponents"
                  :label="$translate('Select component')"
                  solo
                  v-model="selectedComponent"
                  item-text="name"
                  item-value="id"
                  return-object
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="auto" v-if="selectedComponent && !readonly">
                <v-btn color="error" text @click="removeComponent"><v-icon left>mdi-delete</v-icon>{{ $translate('Remove') }}</v-btn>
              </v-col>
            </v-row>
            <v-row v-if="selectedComponent && !readonly">
              <v-col cols=12 md=6>
                <v-text-field :label="$translate('Name')" v-model="selectedComponent.name"></v-text-field>
              </v-col>
              <v-col cols=12 md=4>
                <v-select
                  :items="component_types"
                  :label="$translate('Select component type')"
                  solo
                  v-model="selectedComponent.type"
                  item-text="name"
                  item-value="id"
                  persistent-hint
                  :hint="component_types.find(x => x.id == selectedComponent.type) && component_types.find(x => x.id == selectedComponent.type).hint"
                />
              </v-col>
            </v-row>
            <div v-if="selectedComponent && selectedComponent.type != 'vue3'" class="component-usage-box">
              <span class="component-usage-label">{{ $translate('Use in other components as:') }}</span>
              <code class="component-usage-tag">&lt;zoezi-addon-{{selectedComponent.id}} /&gt;</code>
              <v-icon x-small @click="copyComponentTag" style="cursor: pointer" :color="componentTagCopied ? 'success' : ''">
                {{ componentTagCopied ? 'mdi-check' : 'mdi-content-copy' }}
              </v-icon>
            </div>

            <div v-if="selectedComponent">
              <v-tabs>
                <v-tab @change="refreshEditor('html')">HTML</v-tab>
                <v-tab @change="refreshEditor('js')">Javascript</v-tab>
                <v-tab @change="refreshEditor('css')">CSS</v-tab>
                <v-tab v-if="selectedComponent.type == 'vue3'" @change="refreshEditor('dependencies')">{{ $translate('Dependencies') }}</v-tab>
                <v-tab v-if="selectedComponent.type == 'vue3'">{{ $translate('Compilation') }}</v-tab>

                <v-tab-item>
                  <CodeEditor ref="html" v-model="selectedComponent.template" type="html" />
                </v-tab-item>

                <v-tab-item>
                  <CodeEditor ref="js" v-model="selectedComponent.code" type="js"/>
                </v-tab-item>

                <v-tab-item>
                  <CodeEditor ref="css" v-model="selectedComponent.css" type="css" />
                </v-tab-item>

                <v-tab-item v-if="selectedComponent.type == 'vue3'">
                  <CodeEditor ref="dependencies" v-model="selectedComponent.dependencies" type="json"/>
                </v-tab-item>

                <v-tab-item v-if="selectedComponent.type == 'vue3'">
                  <v-btn @click="compile(selectedComponent)" :loading="compileResult.compiling" color="primary" :disabled="addonChanged">{{ $translate('Compile') }}</v-btn>

                  <div v-if="compileResult.component_id == selectedComponent.id" class="mt-2">
                    <div v-if="compileResult.result.result">
                        <div><v-icon color="success" class="mr-2">mdi-check</v-icon>{{ $translate('Compilation complete') }}</div>
                        <div>{{ $translate('File size') }}: {{compileResult.result.size}} bytes</div>
                    </div>
                    <div v-else>
                      <div><v-icon color="error" class="mr-2">mdi-alert</v-icon>{{ $translate('Compilation failed') }}</div>
                      <div style="white-space: pre-line" v-text="compileResult.result.output" class="mt-2"></div>
                    </div>
                  </div>
                </v-tab-item>

              </v-tabs>
            </div>
          </v-tab-item>

          <v-tab-item>
            <v-row>
              <v-col cols=12 md=6>
                <v-btn color="primary" dark class="mb-2" @click="newApi" v-if="!readonly">{{ $translate('New API') }}</v-btn>
                <data-dialog ref="api_dialog" :fields="api_fields" title="API" :readonly="readonly" />

                <v-data-table v-if="changed.apis.length"
                    :headers="apiHeaders"
                    :items="changed.apis"
                    :hide-default-header="$root.isSmallScreen"
                    :hide-default-footer="true"
                    sort-by="name"
                    item-value="id"
                    must-sort
                    class="elevation-1"
                    @click:row="apiClick"
                    :items-per-page="1000"
                  >
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="apiClick(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      v-if="!readonly"
                      small
                      @click.stop="removeApi(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <!-- Funktioner -->
            <v-row>
              <v-col cols=12>
                <data-dialog ref="function_dialog" :title="$translate('New function')" :fields="newfunction_fields" />

                <v-btn v-if="!readonly" color="primary" @click="newFunction">{{ $translate('New function') }}</v-btn>
              </v-col>
            </v-row>
            <v-row v-if="changed.functions && changed.functions.length" align="center">
              <v-col cols=12 md=6>
                <v-select
                  :items="changed.functions"
                  :label="$translate('Select function')"
                  solo
                  v-model="selectedFunction"
                  :item-text="getFunctionName"
                  item-value="id"
                  return-object
                  @change="functionChanged"
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="auto" v-if="selectedFunction">
                <v-btn color="error" text :disabled="readonly" @click="removeFunction">
                  <v-icon left>mdi-delete</v-icon>
                  {{ $translate('Remove') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="selectedFunction">
              <v-col cols=12 md=6>
                <v-text-field :label="$translate('Name')" v-model="selectedFunction.name" :readonly="readonly"></v-text-field>
              </v-col>
              <v-col cols=12 md=3>
                <v-select :label="$translate('Language')" v-model="selectedFunction.language" :items="function_languages" item-text="name" item-value="id" :readonly="readonly" @change="functionChanged" item-disabled="legacy"></v-select>
                <div v-if="selectedFunctionBlocked || selectedFunctionExpiring">
                  <p :class="selectedFunctionBlocked ? 'red--text' : 'orange--text text--darken-3'">{{ selectedFunctionLanguageString }}</p>
                </div>
              </v-col>
              <v-col cols=12 md=3>
                <v-text-field :label="$translate('Max execution time')" v-model.number="selectedFunction.timeout" :readonly="readonly"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="selectedFunction">
              <v-col cols=12>
                <v-tabs v-model="functionTab">
                  <v-tab @change="refreshEditor('functionCode')">{{ $translate('Code') }}</v-tab>
                  <v-tab @change="refreshEditor('functionTestInput')">{{ $translate('Test') }}</v-tab>
                  <v-tab>{{ $translate('Logs') }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="functionTab">
                  <v-tab-item>
                    <CodeEditor ref="functionCode" v-model="selectedFunction.code" :type="selectedFunction.language" />
                  </v-tab-item>

                  <v-tab-item>
                    <v-row>
                      <v-col cols=6>
                        <CodeEditor ref="functionTestInput" v-model="selectedFunction.testInput" type="json" />
                      </v-col>
                      <v-col cols=6>
                        <v-btn color="primary" class="ml-4" @click="testRun" :loading="loading.test" :disabled="!testInputOk">{{ $translate('Test function') }}</v-btn>

                        <div v-if="testOutput.function_id == selectedFunction.id" class="mt-2">
                          <div v-if="testOutput.success">
                              <div><v-icon color="success" class="mr-2">mdi-check</v-icon>{{ $translate('Ran without errors') }}</div>
                          </div>
                          <div v-else>
                            <div><v-icon color="error" class="mr-2">mdi-alert</v-icon>{{ $translate('Ran with errors') }}</div>
                          </div>
                          <div style="white-space: pre-line" v-text="testOutput.data" class="mt-2"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item>
                    <v-row>
                      <v-col cols=12>
                        <v-btn color="primary" class="ml-4" @click="getLogs" :loading="loading.logs">{{ $translate('Fetch logs') }}</v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=12>
                        <div v-for="message in functionLog" style="white-space: pre-line" :key="message">{{message}}</div>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>

              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item>
            <div class="pa-4">
              <h3 class="mb-4">{{ $translate('Review') }}</h3>
              <v-row v-if="selectedVersion.review_comments && selectedVersion.review_comments.length">
                <v-col cols=12>
                  <v-timeline>
                    <v-timeline-item
                      v-for="(comment,index) in selectedVersion.review_comments"
                      :left="comment.supplier"
                      :right="!comment.supplier"
                      :key="index"
                      >
                      <template v-slot:icon>
                        <v-avatar>
                          <img :src="comment.imageurl" style="width: 50px; height: 50px" />
                        </v-avatar>
                      </template>
                      <v-card class="pa-4" elevation="5">
                        <b>{{comment.time}}</b><span class="ml-4">{{comment.developer_name}}</span><br><br>
                        <span style="white-space: break-spaces">{{comment.text}}</span>
                      </v-card>
                    </v-timeline-item>
                  </v-timeline>
                </v-col>
              </v-row>

              <v-row v-if="selectedVersion.state == 'test' && hasReviewErrors()">
                <v-col cols=12>
                  <v-alert :type="error.type" v-for="error in getReviewErrors()" :key="error.id">{{error.text}}</v-alert>
                </v-col>
              </v-row>

              <v-row v-if="selectedVersion.state == 'test'">
                <v-col cols=12>
                  <v-textarea
                    v-model="reviewComment"
                    :placeholder="$translate('Write any comment to Zoezi reviewers')"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols=12>
                  <v-btn color="primary" @click="review" :disabled="readonly || selectedVersion.state != 'test' || addonChanged || hasReviewErrors()">
                    {{ $translate('Submit for review') }}
                  </v-btn>

                  <v-btn v-if="selectedVersion.state == 'review'" color="error" @click="cancelReview">
                    {{ $translate('Cancel review') }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-if="($root.reviewer.approve || $root.reviewer.reject) && selectedVersion.state == 'review'">
                <v-col cols=12>
                  <v-textarea
                    v-model="rejectReason"
                    :placeholder="$translate('If rejecting, provide reason why the addon cannot be approved')"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row v-if="($root.reviewer.approve || $root.reviewer.reject) && selectedVersion.state == 'review'">
                <v-col cols=12>
                  <v-btn v-if="$root.reviewer.approve" color="primary" @click="approve()" :disabled="rejectReason">{{ $translate('Approve') }}</v-btn>

                  <v-btn v-if="$root.reviewer.reject" color="error" @click="reject()" :disabled="!rejectReason">{{ $translate('Reject') }}</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="pa-4">
              <h3 class="mb-4">{{ $translate('Event Log') }}</h3>
              <p class="mb-4">{{ $translate('Track errors and events from webhooks, functions, and custom reports.') }} <a :href="apiDocBaseUrl + '#POST/addon/event/report_from_addon'" target="_blank" class="text-decoration-none"><v-icon small color="primary">mdi-information-outline</v-icon></a></p>
              <event-list :addon-id="addon.id" :webhooks="changed.webhooks" v-if="addon" @go-to-function="goToFunctionCode"></event-list>
            </div>
          </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
        <div style="height: 60px">&nbsp;</div>
          <v-footer app style="z-index: 6">
        <div v-if="!validLanguage" class="red--text w-12">{{ unsavableLanguageString }}</div>
            <a class="text-decoration-none" :href="'https://' + (changed.test_hostname || 'developer.zoezi.se') + '/apidoc/'" target="_blank"><v-icon class="mr-2" color="primary">mdi-book-open-variant</v-icon>{{ $translate('API documentation') }}</a>
            <a v-if="addon.version.state == 'test' && changed.test_hostname" class="ml-8 text-decoration-none" :href="'https://' + changed.test_hostname" target="_blank">{{ $translate('Test system') }}: {{changed.test_hostname}}</a>
            <v-switch v-if="addon.version.state == 'test' && changed.test_hostname && loggedInOnTestSystem" :input-value="startedOnTestSystem" class="ml-8" :label="$translate('Addon added')" @change="toggleStarted" :loading="startedOnTestSystem === null" />
            <span v-if="addon.version.state == 'test' && changed.test_hostname && !loggedInOnTestSystem && loggedInOnTestSystem !== null" class="ml-8">{{ $translate('Not logged in on test system') }}</span>
            <v-spacer></v-spacer>

              <v-btn class="ml-2" v-if="addon.version.state == 'live' && $root.reviewer.hotpatch" color="error" :disabled="!addonChanged || !valid || !validLanguage" @click="hotpatch" :loading="loading.hotpatch">
                {{ $translate('Hotpatch') }}
              </v-btn>

              <v-btn class="ml-2" v-if="addon.version.state == 'test' || (addon.version.state == 'review' && $root.reviewer.hotpatch)" color="primary" :disabled="!addonChanged || !valid || !validLanguage" @click="save" :loading="loading.save">
                {{ $translate('Save') }}
              </v-btn>

              <v-btn class="ml-2" v-if="addon.version.state == 'live'" color="primary" @click="newVersion" :loading="loading.newVersion">
                {{ $translate('Create new version') }}
              </v-btn>
          </v-footer>
      </v-form>
    </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import {translate, getRandomId, getRandomIdShort, decimalR, categories} from '@/utils.js';
import CodeEditor from '../views/CodeEditor.vue'

let widget_types = [
  {name: 'Staff dashboard', id: 'staffdashboard'},
  {name: 'Customer card', id: 'customercard'},
  {name: 'Staff card', id: 'staffcard'}
];

let widget_subtypes = [
  {name: 'General', id: 'general'},
  {name: 'Economy', id: 'economy'},
  {name: 'Report', id: 'report'}
];

let widget_invocation_types = [
  {name: 'Built-in function', id: 'function'},
  {name: 'External URL', id: 'external'},
  {name: 'Component', id: 'component'}
];

let nodejs_template = `let zoezi = require('zoezi');

exports.main = (data, context) => {
    zoezi.init(data.apikey, data.hostname);
    data.events.forEach(e => {
        // Do something
    });

    context.succeed('');
};
`;

let python_template = `import zoezi

def main(data, context):
    zoezi.init(data['apikey'], data['hostname'])
    for e in data['events']:
        # Do something
`;

let python_widget_template = `import zoezi

def main(data, context):
    zoezi.init(data['apikey'], data['hostname'])
    return '<html>Hello world</html>'
`;


let nodejs_widget_template = `let zoezi = require('zoezi');

exports.main = (data, context) => {
    zoezi.init(data.apikey, data.hostname);
    context.succeed('<html>Hello world</html>');
};
`;

let nodejs_api_template = `let zoezi = require('zoezi');

exports.main = (data, context, callback) => {
    zoezi.init(data.apikey, data.hostname);
    let param1 = data.params.param1;
    let param2 = data.params.param2;
    if (param2 == undefined) {
      callback(Error('Missing parameter: param2'), null)
      return;
    }
    callback(null, {result: 'ok'});
};
`;

let python_api_template = `import zoezi
import json

def main(data, context):
    zoezi.init(data['apikey'], data['hostname'])
    param1 = data['params'].get('param1')
    param2 = data['params'].get('param2')
    if not param2:
        raise Exception('Missing parameter: param2')
    return json.dumps({'result': 'ok'})
`;

let nodejs_mailing_template = `let zoezi = require('zoezi');

exports.main = (data, context) => {
  zoezi.init(data.apikey, data.hostname);
  let subject = data.mail.subject;
  let message = data.mail.message;
  context.succeed('');
};
`;

let python_mailing_template = `import zoezi

def main(data, context):
  zoezi.init(data['apikey'], data['hostname'])
  subject = data['mail'].get('subject')
  message = data['mail'].get('message')
`;

// Two separate things are tracked per runtime, and conflating them would either freeze add-ons that
// still deploy fine or keep offering runtimes with no future:
//   legacy    - no longer selectable, for a new function or by switching an existing one to it
//   blockDate - the day the runtime becomes undeployable; saving is refused from then on. This is
//               AWS's block-CREATE date, not its later block-update date, because publishing a new
//               version creates Lambdas rather than updating them - see RUNTIME_BLOCK_DATES in
//               plug/addon/ajax.py for the full reasoning.
// A runtime with no blockDate has no known end of life; it is never refused. Keep the dates in step
// with RUNTIME_BLOCK_DATES in plug/addon/ajax.py - the two gates must agree.
const FUNCTION_LANGUAGES = [
  {name: 'Node.js 24', id: 'nodejs24.x', mode: 'text/javascript', templates: {webhook: nodejs_template, widget: nodejs_widget_template, api: nodejs_api_template, mailing: nodejs_mailing_template}  },
  {name: 'Node.js 20', id: 'nodejs20.x', mode: 'text/javascript', templates: {webhook: nodejs_template, widget: nodejs_widget_template, api: nodejs_api_template, mailing: nodejs_mailing_template}, legacy: true, blockDate: '2027-07-29'  },
  {name: 'Node.js 18', id: 'nodejs18.x', mode: 'text/javascript', templates: {webhook: nodejs_template, widget: nodejs_widget_template, api: nodejs_api_template, mailing: nodejs_mailing_template}, legacy: true, blockDate: '2027-07-29'  },
  {name: 'Node.js 16', id: 'nodejs16.x', mode: 'text/javascript', templates: {webhook: nodejs_template, widget: nodejs_widget_template, api: nodejs_api_template, mailing: nodejs_mailing_template}, legacy: true, blockDate: '2027-07-29'  },
  {name: 'Node.js 14', id: 'nodejs14.x', mode: 'text/javascript', templates: {webhook: nodejs_template, widget: nodejs_widget_template, api: nodejs_api_template, mailing: nodejs_mailing_template}, legacy: true, blockDate: '2024-01-09'  },
  // Kept listed although it can no longer be selected: add-on versions still reference it, and
  // the editor resolves a function's runtime by looking it up here. Dropping the entry makes
  // those add-ons unopenable.
  {name: 'Node.js 12', id: 'nodejs12.x', mode: 'text/javascript', templates: {webhook: nodejs_template, widget: nodejs_widget_template, api: nodejs_api_template, mailing: nodejs_mailing_template}, legacy: true, blockDate: '2023-03-31'  },
  {name: 'Python 3.13', id: 'python3.13', mode: 'text/x-python', version: 3, templates: {webhook: python_template, widget: python_widget_template, api: python_api_template, mailing: python_mailing_template } },
  {name: 'Python 3.12', id: 'python3.12', mode: 'text/x-python', version: 3, templates: {webhook: python_template, widget: python_widget_template, api: python_api_template, mailing: python_mailing_template } },
  {name: 'Python 3.9', id: 'python3.9', mode: 'text/x-python', version: 3, templates: {webhook: python_template, widget: python_widget_template, api: python_api_template, mailing: python_mailing_template }, legacy: true, blockDate: '2027-07-29' },
  {name: 'Python 3.8', id: 'python3.8', mode: 'text/x-python', version: 3, templates: {webhook: python_template, widget: python_widget_template, api: python_api_template, mailing: python_mailing_template }, legacy: true, blockDate: '2027-07-29' },
  {name: 'Python 2.7', id: 'python2.7', mode: 'text/x-python', version: 2, templates: {webhook: python_template, widget: python_widget_template, api: python_api_template, mailing: python_mailing_template }, legacy: true, blockDate: '2021-07-15' },
//  {name: 'Ruby 2.7', id: 'ruby2.7', mode: 'text/x-ruby', templates: {webhook: ruby_template, widget: ruby_widget_template } },
  //{name: 'Java 11', id: 'java11', mode: 'text/x-java'},
  //{name: 'Go 1.x', id: 'go1.x', mode: 'text/x-go'}, (requires us to compile the code on backend)
  //{name: '.NET Core 3.1', id: 'dotnetcore3.1', mode: 'text/x-csharp'},
];

let functions_templates = [
  {name: 'Template for widget', id: 'widget'},
  {name: 'Template for webhooks', id: 'webhook'},
  {name: 'Template for API', id: 'api'},
  {name: 'Template for mailing', id: 'mailing'}
];

let component_types = [
  {id: 'vue2', name: 'Vue 2 (website and admin)', hint: 'For website and admin page'},
  {id: 'vue3', name: 'Vue 3 (admin)', hint: 'For admin page. Faster, more efficient and more features'},
];

// Tab name to index mapping
const TAB = {
  info: 0,
  description: 1,
  price: 2,
  settings: 3,
  notifications: 4,
  widgets: 5,
  webhooks: 6,
  mailinghandlers: 7,
  components: 8,
  apis: 9,
  functions: 10,
  review: 11,
  log: 12
};

// Keys this portal keeps on a function but never sends to AWS - see NON_DEPLOYED_FUNCTION_KEYS in
// plug/addon/ajax.py, which must list the same ones.
const NON_DEPLOYED_FUNCTION_KEYS = ['testInput'];

function deployedFunction(addonFunction) {
  return addonFunction ? _.omit(addonFunction, NON_DEPLOYED_FUNCTION_KEYS) : addonFunction;
}

export default {
  name: 'showAddonComponent',

  components: {
    CodeEditor
  },

  data: () => ({
    TAB,
    addon: null,
    valid: false,
    events: [],
    permissions: [],
    domains: [],
    chains: [],
    modules: [],
    selectedVersion: null,
    readonly: true,
    tab: 0,
    componentTagCopied: false,
    tabNames: ['info', 'description', 'price', 'settings', 'notifications', 'widgets', 'webhooks', 'mailinghandlers', 'components', 'apis', 'functions', 'review', 'log'],
    functionTab: null,
    nameRules: [],
    requiredEmail: [],
    emailRules: [],
    requiredRules: [],
    hostnamelistRules: [],
    decimalRule: [],
    changed: {
      name: null,
      image: null,
      image_object: null,
      supplier_mail: null,
      onstart_mail: null,
      onstart_text: null,
      start_fee: null,
      price_per_month: null,
      use_transactions: false,
      free_uses_per_month: null,
      price_per_usage: null,
      price_per_usage_percent: null,
      description: null,
      webhooks: [],
      mailinghandlers: [],
      widgets: [],
      for_all: null,
      hostnames: null,
      test_hostname: null,
      settings: [],
      permissions_granted: [],
      permissions_provided: [],
      modules: [],
      price_rules: [],
      available_rules: [],
      functions: [],
      category: null,
      screenshots: [],
      unique_apikey: false,
      usage_name: null,
      components: [],
      apis: [],
      preview: null,
    },
    notificationSettings: {
      notification_emails: null,
      notification_errors: true,
      notification_warnings: false,
      notification_info: false,
      notification_mode: 'smart'
    },
    originalNotificationSettings: {
      notification_emails: null,
      notification_errors: true,
      notification_warnings: false,
      notification_info: false,
      notification_mode: 'smart'
    },
    showWebhookDialog: false,
    editingWebhookItem: {
      name: '',
      useFunction: true,
      functionName: '',
      url: '',
      events: [],
      actions: []
    },
    editingWebhookItemIndex: -1,
    defaultWebhookItem: {
      name: '',
      useFunction: true,
      functionName: '',
      url: '',
      events: [],
      actions: []
    },
    rejectReason: null,
    reviewComment: null,
    code: '',
    cmOption: {
        tabSize: 4,
        indentUnit: 4,
        lineNumbers: true,
        matchBrackets: true,
        mode: 'python',
        readOnly: true
    },
    selectedFunction: null,
    selectedComponent: null,
    functionLog: [],
    loading: {
      save: false,
      logs: false,
      hotpatch: false,
      image: false,
      screenshot: false,
      newVersion: false,
      review: false,
      cancelreview: false,
      approve: false,
      reject: false,
      test: false,
      gitInit: false,
      testNotification: false,
      testError: false,
      saveNotifications: false
    },
    selectedScreenshot: 0,
    tmp: {
      modules: '',
      permissions_granted: '',
      webhook: ''
    },
    packages: [],
    defaultForPackage: [],
    recommendedForPackage: [],
    defaultForPackageOrig: [],
    recommendedForPackageOrig: [],
    startedOnTestSystem: null,
    loggedInOnTestSystem: null,
    compileResult: {
      compiling: false,
      component_id: '',
      result: null
    },
    testOutput: {
      data: '',
      success: false,
      function_id: ''
    },
    showImageDialog: false,
    showScreenshotDialog: false,
    gitRepoStatus: null
  }),
  mounted() {
    // Initialize validation rules with translations
    this.nameRules = [v => v.length ? true : this.$translate('The addon must have a name')];
    this.requiredEmail = [
      v => /.+@.+\..+/.test(v) || this.$translate('Invalid email address'),
      v => v ? true : this.$translate('Value is required')
    ];
    this.emailRules = [v => !v ? true : (/.+@.+\..+/.test(v) || this.$translate('Invalid email address'))];
    this.requiredRules = [v => v ? true : this.$translate('Value is required')];
    this.hostnamelistRules = [v => {
      if (v) {
        let parts = v.split(',');
        for (let i = 0; i < parts.length; ++i) {
          let p = parts[i];
          let hparts = p.split('.');
          if (hparts.length != 3 || hparts[2] != 'se' || ['gymsystem', 'zoezi', 'lokalsystem'].indexOf(hparts[1]) == -1) return this.$translate('Invalid system address');
        }
      }
      return true;
    }];
    this.decimalRule = [v => !v || decimalR.test(v) ? true : this.$translate('Invalid decimal number')];

    this.$root.getDeveloper().then(() => {
      this.updateAddon();
      this.getSupplierData();
    });

    // Handle query param for opening specific tab (e.g., ?tab=status)
    const tabParam = this.$route.query.tab;
    if (tabParam) {
      const tabIndex = this.tabNames.indexOf(tabParam);
      if (tabIndex !== -1) {
        this.tab = tabIndex;
      }
    }

    document.addEventListener("keydown", this.keydown);

    // Only fetch packages if user has reviewer.list permission (admin/reviewer only)
    if (this.$root.reviewer && this.$root.reviewer.list) {
      fetch('/api/package/get').then(response => response.json() ).then(data => {
        if (!_.isArray(data)) {
          this.defaultForPackageOrig = [];
          this.recommendedForPackageOrig = [];
          return;
        }

        this.packages = data.slice();

        const addon_id = this.$route.params.addon_id;
        if(addon_id) {
          const addons = data.filter(p => {
            return p.addons && p.addons.includes(addon_id);
          }).map(p => p.name);
          const recommended = data.filter(p => {
            return p.recommended && p.recommended.includes(addon_id);
          }).map(p => p.name);

          this.defaultForPackage = addons.slice();
          this.defaultForPackageOrig = addons.sort();
          this.recommendedForPackage = recommended.slice();
          this.recommendedForPackageOrig = recommended.sort();
        }

      });
    }
  },
  computed: {
    apiDocBaseUrl() {
      return 'https://' + window.location.hostname + '/apidoc/';
    },
    component_types() {
      this.$root.language; // Make reactive to language changes
      return component_types.map(t => ({...t, name: this.$translate(t.name), hint: this.$translate(t.hint)}));
    },
    categories() {
      this.$root.language; // Make reactive to language changes
      return categories.map(c => ({...c, name: this.$translate(c.name)}));
    },
    emailListRules() {
      return [
        v => {
          if (!v) return true;
          let emails = v.split(',');
          for (let email of emails) {
            email = email.trim();
            if (!email) {
              return this.$translate('Invalid email format');
            }
            if (!/.+@.+\..+/.test(email)) {
              return this.$translate('Invalid email address') + ': ' + email;
            }
          }
          return true;
        }
      ];
    },
    webhookHeaders() {
      return [{text: this.$translate('Name'), value: 'name'}, {text: this.$translate('Events'), value: 'events'}, {text: '', value: 'action', sortable: false}];
    },
    widgetHeaders() {
      return [{text: this.$translate('Name'), value: 'name'}, {text: this.$translate('Shown where?'), value: 'type'}, {text: '', value: 'action', sortable: false}];
    },
    mailingHandlerHeaders() {
      return [{text: this.$translate('Name'), value: 'name'}, {text: '', value: 'action', sortable: false}];
    },
    settingsHeaders() {
      return [{text: this.$translate('Name'), value: 'name'}, {text: '', value: 'action', sortable: false}];
    },
    apiHeaders() {
      return [{text: this.$translate('Name'), value: 'name'}, {text: this.$translate('Path'), value: 'path'}, {text: '', value: 'action', sortable: false}];
    },
    permissionsHeaders() {
      return [{text: this.$translate('Name'), value: 'id'}, {text: '', value: 'action', sortable: false}];
    },
    today() {
      return new Date().toLocaleDateString('sv-SE');
    },
    function_languages() {
      return FUNCTION_LANGUAGES.map(l => {
        if (!l.blockDate) {
          return l;
        }

        // A date already behind us states what happened; one still ahead states a deadline. Using
        // the future wording for a 2023 date reads as though there is still time to act.
        const key = l.blockDate <= this.today ? 'Support ended {0}' : 'Deprecated {0}';
        const suffix = this.$translate(key).replace('{0}', l.blockDate);

        return Object.assign({}, l, {name: `${l.name} [${suffix}]`});
      });
    },
    // Runtimes AWS no longer accepts, so saving has to be refused. Recomputed from today's date so
    // the block starts on its own - see blocked_languages() in plug/addon/ajax.py, which applies the
    // same rule to the same dates.
    blockedLanguages() {
      return this.function_languages
        .filter(x => x.blockDate && x.blockDate <= this.today)
        .map(x => x.id);
    },
    // Functions on a blocked runtime that this save would actually change. Only these can stop a
    // save. Blocking on every blocked function would instead freeze the whole add-on until all of
    // them are migrated, and would be stricter than the API, which applies this same rule in
    // verify_language_supported.
    unsavableFunctions() {
      return this.changed.functions.filter(fun =>
        this.blockedLanguages.includes(fun.language) && this.isFunctionChanged(fun));
    },
    validLanguage() {
      return this.unsavableFunctions.length === 0;
    },
    // Every function on a blocked runtime, changed or not: what the supplier still has left to
    // migrate, as opposed to what is stopping this particular save.
    blockedFunctionCount() {
      return this.changed.functions.filter(fun => this.blockedLanguages.includes(fun.language)).length;
    },
    selectedFunctionBlocked() {
      return !!this.selectedFunction && this.blockedLanguages.includes(this.selectedFunction.language);
    },
    // A runtime whose block date is still ahead: worth telling the supplier about, but it must not
    // read like the add-on is already stuck, because it is not.
    selectedFunctionExpiring() {
      if (!this.selectedFunction || this.selectedFunctionBlocked) {
        return false;
      }

      const language = this.function_languages.find(x => x.id == this.selectedFunction.language);

      return !!language && !!language.blockDate;
    },
    selectedFunctionLanguageString() {
      if (!this.selectedFunction) {
        return '';
      }

      const language = this.function_languages.find(x => x.id == this.selectedFunction.language);
      const languageName = language ? language.name : this.selectedFunction.language;

      // Still maintainable until its block date, so it gets a heads-up rather than the blocked
      // wording.
      if (this.selectedFunctionExpiring) {
        return this.$translate('This function uses a runtime that will stop accepting changes ({0}). Switch to a supported runtime before then.')
          .replace('{0}', languageName);
      }

      const parts = [
        this.$translate('This function uses a runtime that is no longer supported ({0}).')
          .replace('{0}', languageName)
      ];

      const others = this.blockedFunctionCount - 1;
      if (others > 0) {
        parts.push(this.$translate('Another {0} function(s) also use runtimes that are no longer supported.')
          .replace('{0}', others));
      }
      parts.push(this.$translate('The addon keeps working, and other functions can still be changed, but this one must switch to a supported runtime before it can be changed.'));

      return parts.join(' ');
    },
    unsavableLanguageString() {
      const count = this.$translate('{0} changed function(s) use runtimes that are no longer supported.')
        .replace('{0}', this.unsavableFunctions.length);

      return `${count} ${this.$translate('Switch them to a supported runtime to save. The addon keeps working in the meantime.')}`;
    },
    blockedLanguageReviewString() {
      const count = this.$translate('{0} function(s) use runtimes that are no longer supported.')
        .replace('{0}', this.blockedFunctionCount);

      return `${count} ${this.$translate('They must be switched to a supported runtime before the addon can be submitted for review.')}`;
    },
    addonChanged() {

      function diff(orig, data) {
        if(orig.length !== data.length) return true;
        data = data.slice().sort();
        for(let i=0; i<orig.length; i++)
          if(orig[i] != data[i]) return true;
        return false;
      }

      if(diff(this.defaultForPackageOrig, this.defaultForPackage)) return true;
      if(diff(this.recommendedForPackageOrig, this.recommendedForPackage)) return true;
      return JSON.stringify(this.getSubmitItem(false)) != JSON.stringify(this.getOriginalItem());
    },
    notificationSettingsChanged() {
      return JSON.stringify(this.notificationSettings) !== JSON.stringify(this.originalNotificationSettings);
    },
    sortedComponents() {
      return this.changed.components.sort((a,b) => a.name.localeCompare(b.name));
    },
    canRemove() {
      return this.$root.reviewer.hotpatch;
    },
    testInputOk() {
      if (!this.selectedFunction) {
        return false;
      }

      try {
        JSON.parse(this.selectedFunction.testInput);
        return true;
      } catch {
        return false;
      }
    },
    webhook_actions() {
      return [{id: 'add', name: this.$translate('Addition')}, {id: 'update', name: this.$translate('Update')}, {id: 'delete', name: this.$translate('Deletion')}];
    },
    settings_fields() {
      return [
        {id: 'name', label: this.$translate('Name'), required: true, type: 'text'},
        {id: 'type', label: this.$translate('Type'), required: true, type: 'select', options: [
          {id: 'text', name: this.$translate('Text')},
          {id: 'number', name: this.$translate('Number')},
          {id: 'checkbox', name: this.$translate('Checkbox')}
        ]}
      ];
    },
    permissions_fields() {
      return [{id: 'id', label: this.$translate('Name'), required: true, type: 'text'}];
    },
    priceHeaders() {
      return [
        {text: this.$translate('Chain'), value: 'chain'},
        {text: this.$translate('Domain'), value: 'domain'},
        {text: this.$translate('Start fee'), value: 'start_fee'},
        {text: this.$translate('Price per month'), value: 'price_per_month'},
        {text: '', value: 'action', sortable: false}
      ];
    },
    priceHeadersTransaction() {
      return [
        {text: this.$translate('Chain'), value: 'chain'},
        {text: this.$translate('Domain'), value: 'domain'},
        {text: this.$translate('Start fee'), value: 'start_fee'},
        {text: this.$translate('Price per month'), value: 'price_per_month'},
        {text: this.$translate('Free transactions per month'), value: 'free_uses_per_month'},
        {text: this.$translate('Price per transaction'), value: 'price_per_usage'},
        {text: this.$translate('Percent per transaction'), value: 'price_per_usage_percent'},
        {text: '', value: 'action', sortable: false}
      ];
    },
    price_fields() {
      return [
        {id: 'chain', label: this.$translate('Chain'), type: 'select', options: this.chains, clearable: true},
        {id: 'domain_id', label: this.$translate('Domain'), type: 'select', options: this.domains, getName: this.getDomainName},
        {id: 'start_fee', label: this.$translate('Start fee'), type: 'price'},
        {id: 'price_per_month', label: this.$translate('Price per month'), type: 'price'},
      ];
    },
    price_fields_transaction() {
      return [
        {id: 'chain', label: this.$translate('Chain'), type: 'select', options: this.chains, clearable: true},
        {id: 'domain_id', label: this.$translate('Domain'), type: 'select', options: this.domains, getName: this.getDomainName},
        {id: 'start_fee', label: this.$translate('Start fee'), type: 'price'},
        {id: 'price_per_month', label: this.$translate('Price per month'), type: 'price'},
        {id: 'free_uses_per_month', label: this.$translate('Free transactions per month'), type: 'number'},
        {id: 'price_per_usage', label: this.$translate('Price per transaction'), type: 'price'},
        {id: 'price_per_usage_percent', label: this.$translate('Percent per transaction'), type: 'decimal'}
      ];
    },
    availableHeaders() {
      return [
        {text: this.$translate('Chain'), value: 'chain'},
        {text: this.$translate('Domain'), value: 'domain'},
        {text: '', value: 'action', sortable: false}
      ];
    },
    available_fields() {
      return [
        {id: 'chain', label: this.$translate('Chain'), type: 'select', options: this.chains, clearable: true},
        {id: 'inverted', label: this.$translate('For all others'), type: 'checkbox', visible: 'chain'},
        {id: 'domain_id', label: this.$translate('Domain'), type: 'select', options: this.domains, getName: this.getDomainName, visible: '!chain'},
      ];
    },
    widget_fields() {
      const translatedWidgetTypes = widget_types.map(t => ({...t, name: this.$translate(t.name)}));
      const translatedWidgetSubtypes = widget_subtypes.map(t => ({...t, name: this.$translate(t.name)}));
      const translatedWidgetInvocationTypes = widget_invocation_types.map(t => ({...t, name: this.$translate(t.name)}));
      return [
        {id: 'name', label: this.$translate('Name'), type: 'text', required: true},
        {id: 'type', label: this.$translate('Shown where?'), type: 'select', options: translatedWidgetTypes, required: true },
        {id: 'subtype', label: this.$translate('Type'), type: 'select', options: translatedWidgetSubtypes, required: true, visible: (fields) => fields.find(x => x.id=='type').value == 'staffdashboard'},
        {id: 'invocationType', label: this.$translate('Invocation type'), type: 'select', options: translatedWidgetInvocationTypes, required: true},
        {id: 'functionName', label: this.$translate('Function'), type: 'select', options: this.changed.functions, visible: (fields) => fields.find(x => x.id=='invocationType').value == 'function'},
        {id: 'url', label: 'URL', type: 'url', visible: (fields) => fields.find(x => x.id=='invocationType').value == 'external'},
        {id: 'component', label: this.$translate('Component'), type: 'select', options: this.changed.components, visible: (fields) => fields.find(x => x.id=='invocationType').value == 'component'},
        {id: 'permission', label: this.$translate('Permission required to show widget'), type: 'select', options: this.permissions, clearable: true },
        {
          id: 'settings',
          label: this.$translate('Settings'),
          ref_dialog: 'widget_permission_list',
          type: 'list',
          newtitle: this.$translate('New setting'),
          fields: [
            {id: 'title', label: this.$translate('Title'), type: 'text', required: true},
            {id: 'name', label: this.$translate('Field name (id)'), type: 'text', required: true},
            {id: 'required', label: this.$translate('Required'), type: 'checkbox'},
            {id: 'type', label: this.$translate('Type'), type: 'select', required: true, options: [
                {id: 'text', name: this.$translate('Text')},
                {id: 'textarea', name: this.$translate('Long text')},
                {id: 'number', name: this.$translate('Number')},
                {id: 'price', name: this.$translate('Price')},
                {id: 'date', name: this.$translate('Date')},
                {id: 'time', name: this.$translate('Time')},
                {id: 'datetime', name: this.$translate('Date and time')},
                {id: 'checkbox', name: this.$translate('Checkbox')}
              ]
            },
            {id: 'default', label: this.$translate('Default value'), type: 'text'},
          ],
          headers: [
            {text: this.$translate('Name'), value: 'title'},
            {text: '', value: 'action', sortable: false}
          ]
        }
      ];
    },
    mailinghandler_fields() {
      return [
        {id: 'name', label: this.$translate('Name'), type: 'text', required: true},
        {id: 'functionName', label: this.$translate('Function'), type: 'select', options: this.changed.functions},
      ];
    },
    api_fields() {
      return [
        {id: 'name', label: this.$translate('Name'), type: 'text', required: true},
        {id: 'path', label: this.$translate('Path'), type: 'text', required: true, rule: (v) => !v || v.startsWith('/') ? true : this.$translate('Must start with /'),
          hint: this.$translate('Use {name} for a value from the path, e.g. /booking/{id}. Path parameters must be Number or String and are always required')},
        {id: 'method', label: this.$translate('Method'), type: 'select', required: true, default: 'POST', options: [{id: 'GET', name: 'GET'}, {id: 'POST', name: 'POST'}]},
        {id: 'functionName', label: this.$translate('Function'), type: 'select', options: this.changed.functions, required: true},
        {id: 'description', label: this.$translate('Description'), type: 'textarea'},
        {id: 'session', label: this.$translate('Logged in user required'), type: 'checkbox'},
        {id: 'permission', label: this.$translate('Permission required to call'), type: 'select', options: this.permissions, clearable: true },
        {
          id: 'params',
          label: this.$translate('Parameters'),
          ref_dialog: 'api_params_list',
          type: 'list',
          newtitle: this.$translate('New parameter'),
          fields: [
            {id: 'name', label: this.$translate('Parameter name'), type: 'text', required: true},
            {id: 'description', label: this.$translate('Description'), type: 'textarea'},
            {id: 'required', label: this.$translate('Required'), type: 'checkbox'},
            {id: 'type', label: this.$translate('Type'), type: 'select', required: true, options: [
                {id: 'string', name: this.$translate('String')},
                {id: 'integer', name: this.$translate('Number')},
                {id: 'datetime', name: this.$translate('Date and time')},
                {id: 'date', name: this.$translate('Date')},
                {id: 'boolean', name: 'Boolean'},
                {id: 'array of integer', name: this.$translate('List of numbers')},
                {id: 'json', name: 'JSON'}
              ]
            }
          ],
          headers: [
            {text: this.$translate('Name'), value: 'name'},
            {text: '', value: 'action', sortable: false}
          ]
        }
      ];
    },
    newfunction_fields() {
      const translatedTemplates = functions_templates.map(t => ({...t, name: this.$translate(t.name)}));
      return [
        {id: 'name', label: this.$translate('Name'), type: 'text', required: true, value: ''},
        {id: 'language', label: this.$translate('Language'), type: 'select', required: true, options: FUNCTION_LANGUAGES.filter(x => !x.legacy)},
        {id: 'template', label: this.$translate('Template'), type: 'select', required: true, options: translatedTemplates},
        {id: 'timeout', label: this.$translate('Max execution time'), type: 'number', value: 3}
      ];
    }
  },
  methods: {
    widgetType(type) {
      return this.$translate(_.find(widget_types, {id: type}).name);
    },
    getAddon(id) {
      return fetch(`/api/addon/supplier/get?addon_id=${id}`).then(response => response.json() ).then(data => {
        this.addon = data;
        this.addon.version = this.addon.versions.sort((a, b) => b.version_number - a.version_number)[0];
        this.selectedVersion = this.addon.version;
        // Initialize notification settings from addon (not version)
        this.notificationSettings = {
          notification_emails: this.addon.notification_emails,
          notification_errors: this.addon.notification_errors !== false,
          notification_warnings: !!this.addon.notification_warnings,
          notification_info: !!this.addon.notification_info,
          notification_mode: this.addon.notification_mode || 'smart'
        };
        this.originalNotificationSettings = JSON.parse(JSON.stringify(this.notificationSettings));
        this.versionSelected();
      });
    },
    updateAddon() {
      this.getAddon(this.$route.params.addon_id);
    },
    getSupplierData() {
      fetch('/api/addon/supplier/data/get').then(response => response.json()).then(data => {
        this.events = data.events.sort((a, b) => this.getEventName(a).localeCompare(this.getEventName(b)))
        this.permissions = data.permissions.sort((a, b) => this.getPermissionName(a).localeCompare(this.getPermissionName(b)));
        this.permissions = this.permissions.map((p) => {
          return {id: p.id, name: this.getPermissionName(p)};
        });
        this.domains = data.domains.sort((a, b) => this.getDomainName(a).localeCompare(this.getDomainName(b)));
        this.chains = data.chains.sort((a, b) => this.getChainName(a).localeCompare(this.getChainName(b)));

        this.modules = data.modules.sort((a, b) => this.getModuleName(a).localeCompare(this.getModuleName(b)));
      });
    },
    review() {
      this.loading.review = true;
      let data = {id: this.selectedVersion.id, comment: this.reviewComment};
      fetch('/api/addon/supplier/review', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then((response) => {
        if (response.status == 200) {
          this.updateAddon();
          this.loading.review = false;
        } else {
          this.showApiError(response, () => { this.loading.review = false; });
        }
      });
    },
    cancelReview() {
      this.loading.cancelreview = true;
      let data = {id: this.selectedVersion.id};
      fetch('/api/addon/supplier/cancelreview', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(() => {
        this.updateAddon();
        this.loading.cancelreview = false;
      });
    },
    sendTestNotification() {
      this.loading.testNotification = true;
      fetch(`/api/addon/supplier/test-notification?addon_id=${this.addon.id}`, {method: 'POST'})
        .then(response => response.json())
        .then(data => {
          this.loading.testNotification = false;
          if (data.success) {
            this.$root.showSnackbar(this.$translate('Test notification sent to') + ': ' + data.emails.join(', '));
          } else {
            this.$root.showErrorDialog(this.$translate('Error'), data.message || this.$translate('Failed to send test notification'));
          }
        })
        .catch(() => {
          this.loading.testNotification = false;
          this.$root.showErrorDialog(this.$translate('Error'), this.$translate('Failed to send test notification'));
        });
    },
    triggerTestError() {
      this.loading.testError = true;
      fetch(`/api/addon/supplier/test-error?addon_id=${this.addon.id}`, {method: 'POST'})
        .then(response => response.json())
        .then(data => {
          this.loading.testError = false;
          if (data.success) {
            this.$root.showSnackbar(this.$translate('Test error created'));
          } else {
            this.$root.showErrorDialog(this.$translate('Error'), data.message || this.$translate('Failed to create test error'));
          }
        })
        .catch(() => {
          this.loading.testError = false;
          this.$root.showErrorDialog(this.$translate('Error'), this.$translate('Failed to create test error'));
        });
    },
    saveNotificationSettings() {
      this.loading.saveNotifications = true;
      const data = {
        addon_id: this.addon.id,
        notification_emails: this.notificationSettings.notification_emails,
        notification_errors: this.notificationSettings.notification_errors,
        notification_warnings: this.notificationSettings.notification_warnings,
        notification_info: this.notificationSettings.notification_info,
        notification_mode: this.notificationSettings.notification_mode
      };
      fetch('/api/addon/supplier/notifications', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)})
        .then(response => response.json())
        .then(data => {
          this.loading.saveNotifications = false;
          if (data.success) {
            // Update original settings to match current
            this.originalNotificationSettings = JSON.parse(JSON.stringify(this.notificationSettings));
            this.$root.showSnackbar(this.$translate('Notification settings saved'));
          } else {
            this.$root.showErrorDialog(this.$translate('Error'), data.message || this.$translate('Failed to save notification settings'));
          }
        })
        .catch(() => {
          this.loading.saveNotifications = false;
          this.$root.showErrorDialog(this.$translate('Error'), this.$translate('Failed to save notification settings'));
        });
    },
    getSubmitItem(all=true) {
      let data = {id: this.selectedVersion.id, name: this.changed.name,
          supplier_mail: this.changed.supplier_mail, start_fee: this.changed.start_fee, price_per_month: this.changed.price_per_month,
          onstart_mail: this.changed.onstart_mail,
          free_uses_per_month: this.changed.free_uses_per_month,
          price_per_usage: this.changed.price_per_usage, price_per_usage_percent: this.changed.price_per_usage_percent,
          description: this.changed.description,
          webhooks: this.changed.webhooks,
          mailinghandlers: this.changed.mailinghandlers,
          widgets: this.changed.widgets,
          onstart_text: this.changed.onstart_text,
          test_hostname: this.changed.test_hostname,
          settings: this.changed.settings, permissions_granted: this.changed.permissions_granted, modules: this.changed.modules,
          permissions_provided: this.changed.permissions_provided,
          price_rules: this.changed.price_rules,
          available_rules: this.changed.for_all ? [] : this.changed.available_rules,
          functions: this.changed.functions,
          apis: this.changed.apis,
          components: this.changed.components,
          category: this.changed.category || null,
          screenshots: this.changed.screenshots,
          image: this.changed.image,
          unique_apikey: this.changed.unique_apikey,
          usage_name: this.changed.usage_name,
          last_modified: this.selectedVersion.last_modified, // We always provide the date of when the loaded version was last changed
          preview: this.changed.preview
        };
        if(all) {
          data.defaultForPackage = this.defaultForPackage;
          data.recommendedForPackage = this.recommendedForPackage;
        }
        return data;
    },
    isFunctionChanged(fun) {
      const original = ((this.selectedVersion && this.selectedVersion.functions) || [])
        .find(existing => existing.id == fun.id);

      return !_.isEqual(deployedFunction(original), deployedFunction(fun));
    },
    getOriginalItem() {
      let data = {id: this.selectedVersion.id, name: this.selectedVersion.name,
          supplier_mail: this.selectedVersion.supplier_mail, start_fee: this.selectedVersion.start_fee, price_per_month: this.selectedVersion.price_per_month,
          onstart_mail: this.selectedVersion.onstart_mail,
          free_uses_per_month: this.selectedVersion.free_uses_per_month,
          price_per_usage: this.selectedVersion.price_per_usage, price_per_usage_percent: this.selectedVersion.price_per_usage_percent,
          description: this.selectedVersion.description,
          webhooks: this.selectedVersion.webhooks || [],
          mailinghandlers: this.selectedVersion.mailinghandlers || [],
          widgets: this.selectedVersion.widgets || [],
          onstart_text: this.selectedVersion.onstart_text,
          test_hostname: this.selectedVersion.test_hostname,
          settings: this.selectedVersion.settings || [], permissions_granted: this.selectedVersion.permissions_granted || [], modules: this.selectedVersion.modules || [],
          permissions_provided: this.selectedVersion.permissions_provided || [],
          price_rules: this.selectedVersion.price_rules || [],
          available_rules: this.selectedVersion.available_rules || [],
          functions: this.selectedVersion.functions || [],
          apis: this.selectedVersion.apis || [],
          components: this.selectedVersion.components || [],
          category: this.selectedVersion.category,
          screenshots: this.selectedVersion.screenshots || [],
          image: this.selectedVersion.image,
          unique_apikey: !!this.selectedVersion.unique_apikey,
          usage_name: this.selectedVersion.usage_name,
          last_modified: this.selectedVersion.last_modified,
          preview: this.selectedVersion.preview
        };
        return data;
    },
    save() {
      if (!this.validLanguage) {
        throw new Error('ADDON PORTAL: Calling save() with invalid function language')
      }

      this.loading.save = true;
      fetch('/api/addon/supplier/version/change', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(this.getSubmitItem())}).then((response) => {
        if (response.status == 200) {
          this.updateAddon();
          this.loading.save = false;
        } else {
          response.json().then(x => {
            this.$root.showErrorDialog('Fel', x.message);
            this.loading.save = false;
          });
        }
      });
    },
    hotpatch() {
      if (!this.validLanguage) {
        throw new Error('ADDON PORTAL: Calling hotpatch() with invalid function language')
      }

      this.loading.hotpatch = true;
      fetch('/api/addon/supplier/version/hotpatch', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(this.getSubmitItem())}).then((response) => {
        if (response.status == 200) {
          this.updateAddon();
          this.loading.hotpatch = false;
        } else {
          response.json().then(x => {
            this.$root.showErrorDialog('Fel', x.message);
            this.loading.hotpatch = false;
          });
        }
      });
    },
    removeVersion() {
      let data = {id: this.selectedVersion.id};
      fetch('/api/addon/supplier/version/remove', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(() => {
        this.updateAddon();
      });
    },
    getState(state) {
      switch (state) {
        case 'test': return this.$translate('In development');
        case 'review': return this.$translate('Under review');
        case 'live': return this.$translate('Published');
      }
    },
    getVersionName(version) {
      return 'Version ' + version.version_number + ' - ' + this.getState(version.state);
    },
    versionSelected() {
      this.changed.name = this.selectedVersion.name;
      this.changed.image = this.selectedVersion.image;
      this.changed.supplier_mail = this.selectedVersion.supplier_mail;
      this.changed.onstart_mail = this.selectedVersion.onstart_mail;
      this.changed.start_fee = this.selectedVersion.start_fee;
      this.changed.price_per_month = this.selectedVersion.price_per_month;
      this.changed.use_transactions = Boolean(Number(this.selectedVersion.price_per_usage) || Number(this.selectedVersion.price_per_usage_percent));
      this.changed.usage_name = this.selectedVersion.usage_name || 'transaktion,transaktioner';
      this.changed.free_uses_per_month = this.selectedVersion.free_uses_per_month;
      this.changed.price_per_usage = this.selectedVersion.price_per_usage;
      this.changed.price_per_usage_percent = this.selectedVersion.price_per_usage_percent;
      this.changed.description = this.selectedVersion.description;
      this.changed.onstart_text = this.selectedVersion.onstart_text;
      this.changed.webhooks = _.cloneDeep(this.selectedVersion.webhooks || []);
      this.changed.mailinghandlers = _.cloneDeep(this.selectedVersion.mailinghandlers || []);
      this.changed.widgets = _.cloneDeep(this.selectedVersion.widgets || []);
      this.changed.for_all = !this.selectedVersion.available_rules || this.selectedVersion.available_rules.length == 0;
      this.changed.available_rules = _.cloneDeep(this.selectedVersion.available_rules || []);
      this.changed.test_hostname = this.selectedVersion.test_hostname;
      this.changed.settings = _.cloneDeep(this.selectedVersion.settings || []);
      this.changed.permissions_granted = _.cloneDeep(this.selectedVersion.permissions_granted || []);
      this.changed.permissions_provided = _.cloneDeep(this.selectedVersion.permissions_provided || []);
      this.changed.modules = _.cloneDeep(this.selectedVersion.modules || []);
      this.changed.price_rules = _.cloneDeep(this.selectedVersion.price_rules || []);
      this.changed.category = this.selectedVersion.category;
      this.readonly = this.selectedVersion.state != 'test' && !this.$root.reviewer.hotpatch;
      this.reviewComment = null;
      this.changed.screenshots = _.cloneDeep(this.selectedVersion.screenshots || []);
      this.changed.functions = _.cloneDeep(this.selectedVersion.functions || []);
      this.changed.components = _.cloneDeep(this.selectedVersion.components || []);
      this.changed.apis = _.cloneDeep(this.selectedVersion.apis || []);
      this.changed.preview = this.selectedVersion.preview;
      this.unique_apikey = this.selectedVersion.unique_apikey;

      if (this.changed.functions.length) {
        this.changed.functions.forEach(f => {
          if (!f.id || f.id.length != 64) {
            f.id = getRandomId();
          }
          if (f.testInput === undefined) {
            f.testInput = '';
          }
        });
        let f = null;
        // Check URL parameter for function selection
        const functionParam = this.$route.query.function;
        if (functionParam) {
          f = _.find(this.changed.functions, {id: functionParam});
        }
        if (!f && this.selectedFunction) {
          f = _.find(this.changed.functions, {name: this.selectedFunction.name})
        }
        if (!f) {
          f = this.changed.functions[0];
        }
        this.selectedFunction = f;
        this.functionChanged();
        // Refresh CodeMirror if navigated via URL param
        if (functionParam && this.tab === TAB.functions) {
          this.$nextTick(() => {
            if (this.$refs.functionCode) {
              this.$refs.functionCode.refreshEditor();
            }
          });
        }
      } else {
        this.selectedFunction = null;
      }

      if (this.changed.components.length) {
        this.changed.components.forEach(c => {
          if (!c.type) {
            c.type = 'vue2';
          }
        })
        let c = null;
        if (this.selectedComponent) {
          c = _.find(this.changed.components, {id: this.selectedComponent.id})
        }
        if (!c) {
          c = this.changed.components[0];
        }
        this.selectedComponent = c;
      } else {
        this.selectedComponent = null;
      }

      if (this.changed.widgets.length) {
        this.changed.widgets.forEach(widget => {
          if (widget.useFunction !== undefined) {
            widget.invocationType = widget.useFunction ? 'function' : 'external';
            delete widget.useFunction;
          }
        })
      }

      if (this.selectedVersion.state == 'test') {
        if (!this.changed.supplier_mail) {
          this.changed.supplier_mail = this.$root.supplier.mail;
        }
      }

      this.getGitRepoStatus();
    },
    newVersion() {
      this.loading.newVersion = true;
      let data = {id: this.addon.id};
      fetch('/api/addon/supplier/version/add', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(() => {
        this.updateAddon();
        this.loading.newVersion = false;
      });
    },
    newFunction() {
      let self = this;
      this.$refs.function_dialog.show().then(function(f) {
        let template = _.find(FUNCTION_LANGUAGES, {id: f.language}).templates[f.template];
        f.code = template || '';
        f.id = getRandomId();
        f.testInput = '';
        self.changed.functions.push(f);
        self.selectedFunction = f;
        self.functionChanged();
      });
    },
    getFunctionName(f) {
      return f.name;
    },
    removeFunction() {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the function?')).then(() => {
        this.changed.functions.splice(this.changed.functions.indexOf(this.selectedFunction), 1);
        this.selectedFunction = this.changed.functions.length ? this.changed.functions[0] : null;
        this.functionChanged();
      });
    },
    functionChanged() {
      if (this.selectedFunction) {
        // A version may reference a runtime we no longer list. Fall back to a plain editor
        // instead of throwing, so the add-on stays openable and can be migrated.
        let ll = _.find(FUNCTION_LANGUAGES, {id: this.selectedFunction.language});
        if (!ll) {
          ll = {mode: 'text/plain', version: undefined};
        }
        this.cmOption.mode = ll.mode;
        this.cmOption.version = ll.version;
        this.cmOption.readOnly = this.readonly;
      }

      this.functionLog = [];
    },
    newComponent() {
      let c = {
        id: getRandomId(),
        name: 'Ny komponent',
        template: '<div>{{text}}</div>',
        code: `{
    zoezi: {
      icon: 'mdi-sheep'
    },
    props: {
      text: {
        title: 'Text',
        type: String,
        default: 'Hej!'
      }
    },
    data: () => ({
    }),
    methods: {
    }
}`,
        css: '',
        dependencies: '',
        type: 'vue2'
      };

      this.changed.components.push(c);
      this.selectedComponent = c;
    },
    removeComponent() {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the component?')).then(() => {
        this.changed.components.splice(this.changed.components.indexOf(this.selectedComponent), 1);
        this.selectedComponent = this.changed.components.length ? this.changed.components[0] : null;
      });
    },
    copyComponentTag() {
      const tag = `<zoezi-addon-${this.selectedComponent.id} />`;
      navigator.clipboard.writeText(tag);
      this.componentTagCopied = true;
      setTimeout(() => { this.componentTagCopied = false; }, 2000);
    },
    getLogs() {
      this.functionLog = [];
      this.loading.logs = true;
      fetch('/api/addon/supplier/function/logs/get?version_id=' + this.selectedVersion.id + '&function_id=' + this.selectedFunction.id).then((response) => response.json().then(x => { this.functionLog = x; this.loading.logs = false; }));
    },
    webhookClick(item) {
      this.showWebhookDialog = true;
      this.editingWebhookItem = Object.assign({}, item);
      this.editingWebhookItemIndex = this.changed.webhooks.indexOf(item);
    },
    goToFunctionCode(functionId) {
      // Navigate to Functions tab and select the function by its ID
      this.$router.replace({
        query: { ...this.$route.query, tab: 'functions', function: functionId }
      }).catch(() => {});
      // Also set directly for immediate feedback
      const func = this.changed.functions.find(f => f.id === functionId);
      if (func) {
        this.tab = TAB.functions;
        this.selectedFunction = func;
        this.functionChanged();
        // Refresh CodeMirror after tab becomes visible
        this.$nextTick(() => {
          if (this.$refs.functionCode) {
            this.$refs.functionCode.refreshEditor();
          }
        });
      }
    },
    closeWebhook() {
      this.showWebhookDialog = false;
        setTimeout(() => {
          this.editingWebhookItem = Object.assign({}, this.defaultWebhookItem)
          this.editingWebhookItemIndex = -1
        }, 300)
    },
    saveWebhook() {
      if (this.editingWebhookItemIndex > -1) {
          Object.assign(this.changed.webhooks[this.editingWebhookItemIndex], this.editingWebhookItem)
        } else {
          this.changed.webhooks.push(this.editingWebhookItem)
        }
        this.closeWebhook()
    },
    getEventName(event) {
      return translate(event.name) + ' (' + event.id + ')';
    },
    getPermissionName(permission) {
      return translate(permission.id);
    },
    getModuleName(module) {
      return translate(module.name);
    },
    getChainName(chain) {
      return chain.name;
    },
    getDomainNameFromId(domain_id) {
      let d = _.find(this.domains, (x) => x.id == domain_id);
      return d && d.name;
    },
    getDomainName(domain) {
      return domain.name + ' (' + domain.hostname + ')';
    },
    removeWebhook(webhook) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the webhook?')).then(() => {
        let i = this.changed.webhooks.indexOf(webhook);
        this.changed.webhooks.splice(i, 1);
        this.closeWebhook();
      });
    },
    widgetClick(item) {
      let self = this;
      let i = this.changed.widgets.indexOf(item);
      this.$refs.widget_dialog.show(item).then(function(value) {
        Vue.set(self.changed.widgets, i, Object.assign({}, self.changed.widgets[i], value));
      })
    },
    newWidget() {
      let self = this;
      this.$refs.widget_dialog.show().then(function(value) {
        value.id = getRandomId();
        self.changed.widgets.push(value);
      });
    },
    removeWidget(widget) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the widget?')).then(() => {
        let i = this.changed.widgets.indexOf(widget);
        this.changed.widgets.splice(i, 1);
      });
    },
    mailingHandlerClick(item) {
      let i = this.changed.mailinghandlers.indexOf(item);
      this.$refs.mailinghandler_dialog.show(item).then((value) => {
        Vue.set(this.changed.mailinghandlers, i, Object.assign({}, this.changed.mailinghandlers[i], value));
      });
    },
    newMailingHandler() {
      this.$refs.mailinghandler_dialog.show().then((value) => {
        value.id = getRandomIdShort();
        this.changed.mailinghandlers.push(value);
      })
    },
    removeMailingHandler(item) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the mailing handler?')).then(() => {
        let i = this.changed.mailinghandlers.indexOf(item);
        this.changed.mailinghandlers.splice(i, 1);
      });
    },
    apiClick(item) {
      let i = this.changed.apis.indexOf(item);
      this.$refs.api_dialog.show(item).then((value) => Vue.set(this.changed.apis, i, Object.assign({}, this.changed.apis[i], value)));
    },
    newApi() {
      this.$refs.api_dialog.show().then((value) => this.changed.apis.push(value));
    },
    removeApi(api) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the API?')).then(() => {
        let i = this.changed.apis.indexOf(api);
        this.changed.apis.splice(i, 1);
      });
    },
    settingsClick(item) {
      let self = this;
      let i = this.changed.settings.indexOf(item);
      this.$refs.settings_dialog.show(item).then(function(value) {
        Vue.set(self.changed.settings, i, Object.assign({}, self.changed.settings[i], value));
      })
    },
    newSetting() {
      let self = this;
      this.$refs.settings_dialog.show().then(function(value) {
        self.changed.settings.push(value);
      });
    },
    removeSetting(item) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the setting?')).then(() => {
        let i = this.changed.settings.indexOf(item);
        this.changed.settings.splice(i, 1);
      });
    },
    permissionsClick(item) {
      let self = this;
      let i = this.changed.permissions_provided.indexOf(item);
      this.$refs.permissions_dialog.show(item).then(function(value) {
        Vue.set(self.changed.permissions_provided, i, Object.assign({}, self.changed.permissions_provided[i], value));
      })
    },
    newPermission() {
      let self = this;
      this.$refs.permissions_dialog.show().then(function(value) {
        self.changed.permissions_provided.push(value);
      });
    },
    removePermission(item) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the permission?')).then(() => {
        let i = this.changed.permissions_provided.indexOf(item);
        this.changed.permissions_provided.splice(i, 1);
      });
    },
    priceRuleClick(item) {
      let self = this;
      let i = this.changed.price_rules.indexOf(item);
      this.$refs.price_dialog.show(item).then(function(value) {
        Vue.set(self.changed.price_rules, i, Object.assign({}, self.changed.price_rules[i], value));
      })
    },
    newPriceRule() {
      let self = this;
      this.$refs.price_dialog.show().then(function(value) {
        self.changed.price_rules.push(value);
      });
    },
    removePriceRule(item) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the price rule?')).then(() => {
        let i = this.changed.price_rules.indexOf(item);
        this.changed.price_rules.splice(i, 1);
      });
    },
    availableRuleClick(item) {
      let self = this;
      let i = this.changed.available_rules.indexOf(item);
      this.$refs.available_dialog.show(item).then(function(value) {
        Vue.set(self.changed.available_rules, i, Object.assign({}, self.changed.available_rules[i], value));
      })
    },
    newAvailableRule() {
      let self = this;
      this.$refs.available_dialog.show().then(function(value) {
        self.changed.available_rules.push(value);
      });
    },
    removeAvailableRule(item) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the availability rule?')).then(() => {
        let i = this.changed.available_rules.indexOf(item);
        this.changed.available_rules.splice(i, 1);
      });
    },
    onImageChanged(file) {
      this.loading.image = true;
      const fr = new FileReader ()
      fr.readAsDataURL(file);
      fr.addEventListener('load', () => {
        let data = {image: fr.result};
        fetch('/api/addon/supplier/image/upload', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data) }).then(response => {
          response.json().then(image => {
            this.changed.image = image.url;
            this.$refs.iuploader.value = null;
            this.loading.image = false;
          })
        });
      })
    },
    onScreenshot(file) {
      this.loading.screenshot = true;
      const fr = new FileReader ()
      fr.readAsDataURL(file);
      fr.addEventListener('load', () => {
        let data = {image: fr.result};
        fetch('/api/addon/supplier/image/upload', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data) }).then(response => {
          response.json().then(image => {
            this.changed.screenshots.push(image.url);
            this.selectedScreenshot = this.changed.screenshots.length - 1;
            this.$refs.uploader.value = null;
            this.loading.screenshot = false;
          })
        });
      })
    },
    // A failed POST must not look like a successful one. The body carries the backend's own
    // message - the runtime guards name the offending functions - so it is shown verbatim rather
    // than replaced with a generic string.
    showApiError(response, done) {
      const fallback = this.$translate('Something went wrong. Try again or contact support.');
      response.json().then(x => {
        this.$root.showErrorDialog(this.$translate('Error'), x.message || fallback);
        done();
      }).catch(() => {
        this.$root.showErrorDialog(this.$translate('Error'), fallback);
        done();
      });
    },
    approve() {
      this.loading.approve = true;
      let data = {id: this.addon.version.id };
      fetch('/api/addon/review/approve', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data) }).then((response) => {
        if (response.status == 200) {
          this.$router.push({name: 'review'});
          this.loading.approve = false;
        } else {
          // Stay on the add-on rather than routing to the review list: the reviewer needs to see
          // which functions the backend refused, and the version is still waiting for them.
          this.showApiError(response, () => { this.loading.approve = false; });
        }
      });
    },
    reject() {
      this.loading.reject = true;
      let data = {id: this.addon.version.id, reason: this.rejectReason };
      fetch('/api/addon/review/reject', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data) }).then((response) => {
        if (response.status == 200) {
          this.$router.push({name: 'review'});
          this.loading.reject = false;
        } else {
          this.showApiError(response, () => { this.loading.reject = false; });
        }
      });
    },
    useTransactionsChange() {
      if (!this.changed.use_transactions) {
        this.changed.free_uses_per_month = null;
        this.changed.price_per_usage = null;
        this.changed.price_per_usage_percent = null;
      }
    },
    getTestSystems() {
      if (this.$root.supplier.id != this.addon.supplier_id) {
        return [{id: this.changed.test_hostname, name: this.changed.test_hostname}];
      }

      return (this.$root.supplier.test_hostnames || '').split(',').map(function(name) {
        return {id: name, name: name};
      });
    },
    removeImage() {
      this.changed.image = null;
    },
    removeScreenshot() {
      this.changed.screenshots.splice(this.selectedScreenshot, 1);
    },
    getReviewErrors() {
      let c = this.changed;
      let errors = [
        {id: 'unsaved', type: 'warning', text: this.$translate('There are unsaved changes'), check: () => this.addonChanged },
        {id: 'description', type: 'error', text: this.$translate('Addon description is missing'), check: () => !c.description || !c.description.length },
        {id: 'supplier_mail', type: 'error', text: this.$translate('Support e-mail is missing'), check: () => !c.supplier_mail || !c.supplier_mail.length },
        {id: 'category', type: 'error', text: this.$translate('Product category is missing'), check: () => !c.category || !c.category.length },
        {id: 'image', type: 'error', text: this.$translate('Addon is missing an image'), check: () => !c.image },
        {id: 'language', type: 'error', text: this.blockedLanguageReviewString, check: () => this.blockedFunctionCount > 0 },
      ];

      return errors.filter(e => e.check() );
    },
    hasReviewErrors() {
      return this.getReviewErrors().length > 0;
    },
    getUsageName(count) {
      let index = count == 1 ? 0 : 1;
      let name = (this.changed.usage_name || 'transaktion,transaktioner');
      let names = name.split(',');
      if (index > names.length-1) {
        index = 0;
      }
      return names[index];
    },
    keydown(e) {
      if (!(e.keyCode === 83 && e.ctrlKey)) {
        return;
      }
      e.preventDefault();

      if (this.readonly || !this.addonChanged) {
        return;
      }

      this.save();
    },
    checkIfStarted() {
      this.startedOnTestSystem = null;
      if (this.changed && this.changed.test_hostname) {
        let protocol = location.protocol;
        fetch(`${protocol}//${this.changed.test_hostname}/api/addon/shop/get`, {credentials: 'include'}).then(response => {
          response.json().then(data => {
            let addon = data.find(x => x.id == this.addon.id);
            this.loggedInOnTestSystem = addon && (addon.can_add || addon.can_remove);
            this.startedOnTestSystem = addon && addon.started;
          })
        })
      }
    },
    toggleStarted(started) {
      this.startedOnTestSystem = null;
      let data = {id: this.addon.id};
      let protocol = location.protocol;
      fetch(`${protocol}//${this.changed.test_hostname}/api/addon/shop/${started ? 'add' : 'remove'}`, {method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'include', body: JSON.stringify(data)}).then(response => {
        this.checkIfStarted();
      });
    },
    compile(component) {
      this.compileResult.compiling = true;
      this.compileResult.component_id = null;
      this.compileResult.result = null;
      fetch(`/api/addon/supplier/component/compile?addonversion_id=${this.selectedVersion.id}&component_id=${component.id}`, {method: 'POST'}).then(response => {
        if (response.status != 200) {
          this.$root.showErrorDialog(this.$translate('Error'), this.$translate('Something went wrong during compilation'));
          this.compileResult.compiling = false;
        } else {
          response.json().then(data => {
            this.compileResult.component_id = component.id;
            this.compileResult.result = data;
            this.compileResult.compiling = false;
          });
        }
      });
    },
    refreshEditor(kind) {
      if (this.$refs[kind] && this.$refs[kind].refreshEditor) {
        this.$refs[kind].refreshEditor();
      }
    },
    remove() {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the addon?')).then(() => {
         fetch('/api/addon/remove?id=' + this.addon.id, {method: 'POST' }).then(() => {
           this.$router.push({name: 'review'});
        });
      });
    },
    testRun() {
      let function_id = this.selectedFunction.id;
      this.testOutput.function_id = null;
      this.loading.test = true;
      let data = JSON.parse(this.selectedFunction.testInput || '{}');
      fetch('/api/addon/supplier/function/test?version_id=' + this.selectedVersion.id + '&function_id=' + function_id, {method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'include', body: JSON.stringify(data)}).then((response) => response.json().then(x => {
        this.testOutput.data = x.data;
        this.testOutput.success = x.success;
        this.testOutput.function_id = function_id;
        this.loading.test = false;
      }));
    },
    gitInit() {
      this.loading.gitInit = true;
      fetch('/api/addon/supplier/git/init?addon_id=' + this.addon.id, {method: 'POST'}).then(() => {
        this.getGitRepoStatus();
        this.loading.gitInit = false;
      });
    },
    getGitRepoStatus() {
      fetch('/api/addon/supplier/git/status?addon_id=' + this.addon.id).then(response => response.json()).then(data => {
        this.gitRepoStatus = data;
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keydown);
  },
  watch: {
    tab(newTab) {
      const tabName = this.tabNames[newTab];
      if (tabName && this.$route.query.tab !== tabName) {
        const query = { ...this.$route.query, tab: tabName };
        // Clear function param when leaving functions tab
        if (tabName !== 'functions') {
          delete query.function;
        }
        this.$router.replace({ query }).catch(() => {});
      }
    },
    selectedFunction(newFunc) {
      // Update URL when function selection changes on functions tab
      if (this.tab === TAB.functions && newFunc && newFunc.id) {
        if (this.$route.query.function !== newFunc.id) {
          this.$router.replace({
            query: { ...this.$route.query, function: newFunc.id }
          }).catch(() => {});
        }
      }
    },
    selectedVersion() {
      this.checkIfStarted();
    },
    'selectedComponent.type'() {
       if (!this.selectedComponent || !this.selectedComponent.code) {
         return;
       }

       if (this.selectedComponent.code.startsWith('{')) {
         this.selectedComponent.code = 'export default ' + this.selectedComponent.code;
       }
    }
  }
}
</script>
